import { Breadcrumb, ConfigProvider, Flex, Space, Tabs } from "antd";
import { MainLayout } from "components/layouts";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CreateProjectInformation from "./CreateTab/CreateProjectInformation";
import SettingProjectAllTask from "./CreateTab/SettingProjectAllTask";
import SettingProjectRoles from "./CreateTab/SettingProjectRoles";
import SettingProjectWorkflow from "./SettingProjectWorkflow";

const ViewSettingProject = ({
    isModalOpen,
    isRoleModalOpen,
    showModal = () => { },
    showRoleModal = () => { },
    onCancel = () => { },
    onRoleModalCancel = () => { },
    employeeOptions = [],
    PROJECT_STATUS = [],
    onSubmit = () => { },
    onTabChange = () => { },
    project = {},
    onSubmitTask = () => { },
    taskOption = [],
    taskPagination = [],
    onEditTask = () => { },
    onViewTask = () => { },
    taskOnEdit = {},
    paginationTask = {},
    onPageTaskChange = () => { },
    roleOption = [],
    onAddEmployee = () => { },
    tableDataSourceCreate = [],
    onSubmitMappingEmployeeRole = () => { },
    employeeRoleMappingPagination = [],
    paginationEmployeeMapping = {},
    onViewRole = () => { },
    onEditRole = () => { },
    isRoleEditModalOpen = false,
    onRoleEditModalCancel = () => { },
    roleModalData = {},
    employeePaginationByRole = [],
    action = null,
    onPageEmployeeByRoleChange = () => { },
    paginationEmployeeByRole = {},
    setSearchTxt = () => { },
    onSearchEmployeeByRole = () => { },
    onRemoveEmployeeFromRole = () => { },
    isLoading = false,
    list = [],
    RenderCell = () => { },
}) => {
    const { t } = useTranslation();

    return (
        <MainLayout>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Breadcrumb items={[
                    { title: t("home.header"), href: "/" },
                    { title: t("setting_timesheet.header"), href: "/setting_timesheet/setting_project" },
                    { title: t("setting_project.header"), href: "/setting_timesheet/setting_project" },
                    { title: t("setting_project.label.view") },
                ]}
                />
                <Flex vertical>
                    <h2>{t("setting_project.label.view")}</h2>
                    <span style={{ color: "#667085" }}>{t("setting_project.label.detail")}</span>
                </Flex>

                <ConfigProvider
                    theme={{
                        components: {
                            Tabs: {
                                itemHoverColor: "var(--tab-color)",
                                itemActiveColor: "var(--tab-color)"
                            },
                        },
                    }}
                >
                    <Tabs destroyInactiveTabPane={true} defaultActiveKey="project_info" onChange={onTabChange}>
                        {
                            <Tabs.TabPane tab={t('setting_project.label.project_info')} key="project_info">
                                <CreateProjectInformation
                                    onSubmit={onSubmit}
                                    employeeOptions={employeeOptions}
                                    PROJECT_STATUS={PROJECT_STATUS}
                                    project={project}
                                    isView={true}
                                />
                            </Tabs.TabPane>
                        }
                        {project?.forAll === "N" && (
                            <Tabs.TabPane tab={t('role.entity')} key="role">
                                <SettingProjectRoles
                                    isRoleModalOpen={isRoleModalOpen}
                                    onRoleModalCancel={onRoleModalCancel}
                                    showRoleModal={showRoleModal}
                                    employeeOptions={employeeOptions}
                                    roleOption={roleOption}
                                    onAddEmployee={onAddEmployee}
                                    tableDataSourceCreate={tableDataSourceCreate}
                                    onSubmitMappingEmployeeRole={onSubmitMappingEmployeeRole}
                                    employeeRoleMappingPagination={employeeRoleMappingPagination}
                                    pagination={paginationEmployeeMapping}
                                    onViewRole={onViewRole}
                                    onEditRole={onEditRole}
                                    isRoleEditModalOpen={isRoleEditModalOpen}
                                    onRoleEditModalCancel={onRoleEditModalCancel}
                                    roleModalData={roleModalData}
                                    employeePaginationByRole={employeePaginationByRole}
                                    action={action}
                                    onPageEmployeeByRoleChange={onPageEmployeeByRoleChange}
                                    paginationEmployeeByRole={paginationEmployeeByRole}
                                    setSearchTxt={setSearchTxt}
                                    onSearchEmployeeByRole={onSearchEmployeeByRole}
                                    onRemoveEmployeeFromRole={onRemoveEmployeeFromRole}
                                    isView={true}
                                />
                            </Tabs.TabPane>
                        )}
                        {
                            <Tabs.TabPane tab={t('setting_timesheet.label.all_work')} key="all_work">
                                <SettingProjectAllTask
                                    isModalOpen={isModalOpen}
                                    showModal={showModal}
                                    onCancel={onCancel}
                                    onSubmit={onSubmitTask}
                                    taskOption={taskOption}
                                    taskPagination={taskPagination}
                                    onEditTask={onEditTask}
                                    onViewTask={onViewTask}
                                    taskOnEdit={taskOnEdit}
                                    paginationTask={paginationTask}
                                    onPageTaskChange={onPageTaskChange}
                                    isView={true}
                                    isLoading={isLoading}
                                    roleOption={roleOption}
                                />
                            </Tabs.TabPane>
                        }
                        {
                            <Tabs.TabPane tab={t('workflow.header')} key="workFlow">
                                <SettingProjectWorkflow
                                    RenderCell={RenderCell}
                                    list={list}
                                />
                            </Tabs.TabPane>
                        }
                    </Tabs>
                </ConfigProvider>
            </Space>
        </MainLayout>
    )
}

export default ViewSettingProject;